module.exports = __webpack_public_path__ + "static/img/office-others.35d4aa3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/office-others.png
// module id = YWT3
// module chunks = 53